import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { PAP } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-cerfa-verification',
  templateUrl: 'cerfa-verification.component.html',
  styleUrls: ['./cerfa-verification.component.less', '../../shared/common.less'],
})

export class CerfaVerificationComponent implements OnInit {
  @Input() papValues: PAP;
  @Input() verificationPercentage: number = 0;
  @Input() validatedCategoriesCount: number = 0;
  @Output() papValuesChange = new EventEmitter<PAP>();
  @Output() numberOfCollegesChanges = new EventEmitter<number>();
  @Output() validatedComponents = new EventEmitter<number>();
  @Output() editRequested = new EventEmitter<string>();

  needCerfa: boolean = true;

  constructor(
    private router: Router,
  ) {}

  onValidatedComponentsChange(validatedCount: number) {
    this.validatedComponents.emit(validatedCount);
  }
  
  onVenueChanges() {
    if (this.papValues.application.mailOption === false) {
      this.papValues.application.address = this.papValues.venue.address;
      this.papValues.application.zip = this.papValues.venue.zipcode;
      this.papValues.application.city = this.papValues.venue.city;
    }
    
    this.papValuesChange.emit(this.papValues);
  }

  onCerfaEditRequested(sectionId: string) {
    this.editRequested.emit(sectionId);
  }

  onHeadcountChange(newHeadcount: any) {
    this.papValues.headcount = { ...newHeadcount };
    this.papValuesChange.emit(this.papValues);
  }

  onPapValuesChange() {
    this.papValuesChange.emit(this.papValues);
  }

  onNumberOfCollegesChanges() {
    this.numberOfCollegesChanges.emit(this.papValues.headcount.numberOfColleges);
  }

  goToPollCreation() {
    this.router.navigate(['/poll-creation']);
  }
  
  ngOnInit(): void {
  }
}
